import { render, staticRenderFns } from "./PolizasRHTabs.vue?vue&type=template&id=6899e6ac&scoped=true&"
import script from "./PolizasRHTabs.vue?vue&type=script&lang=js&"
export * from "./PolizasRHTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899e6ac",
  null
  
)

export default component.exports